import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

angular.module('dashboard');

class batchCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $sessionStorage,
        $cookies,
        $translate,
        API_CONFIG,
        XSRF_TOKEN,
        dateFilter,
        BatchService,
        uiGridConstants,
        BATCH_STATUS,
        LadProviderService,
        DateService,
        UtilSvc
    ) {
        this.$scope = $scope;
        this.$sessionStorage = $sessionStorage;
        this.$cookies = $cookies;
        this.$translate = $translate;
        this.API_CONFIG = API_CONFIG;
        this.XSRF_TOKEN = XSRF_TOKEN;
        this.dateFilter = dateFilter;
        this.BatchService = BatchService;
        this.uiGridConstants = uiGridConstants;
        this.BATCH_STATUS = BATCH_STATUS;
        this.LadProviderService = LadProviderService;
        this.DateService = DateService;
        this.UtilSvc = UtilSvc;
    }

    $onInit() {
        this.sentDates = {
            sentDateFrom: null,
            sentDateTo: null,
            sentTimeFrom: null,
            sentTimeTo: null,
        };

        this.selected = {};

        this.criteriaBat = {
            batchIds: [],
            batchStatus: [],
            folderId: [],
            principalId: [],
            ladProviderId: [],
            sender: [],
            senderEmail: [],
            envelopeId: [],
            companyName: [],
            senderName: [],
            target: [],
            numDoc: [],
            isQuali: null,
        };

        this.criteriaDates = {
            createdDateFrom: [],
            createdDateTo: [],
            createdTimeFrom: [],
            createdTimeTo: [],
            updatedDateFrom: [],
            updatedDateTo: [],
            updatedTimeFrom: [],
            updatedTimeTo: [],
        };

        this.csrf = this.$cookies.get(this.XSRF_TOKEN);
        this.batchsStatus = this.BATCH_STATUS;
        this.ladProviders = this.LadProviderService.findAll();
        // Paramètre indiquant si les critères de recherche doivent être initialisés suivant une configuration spéciale
        var specificForm = this.specificFormBatch;
        var loadFromHisto = this.loadFromHisto;

        this._initBatchsSearchFilter();
        this._initBatchsSearchValues();

        if (specificForm === 'batch_platform_created') {
            this.criteriaBat.isQuali = 'false';
        } else if (specificForm === 'batch_quali_created') {
            this.criteriaBat.isQuali = 'true';
        } else if (specificForm === 'batch_rejected') {
            this.criteriaBat.createdDateFrom = new Date(2015, 0, 1);
            this.criteriaBat.batchStatus = 'NOT_INDEXED';
        }

        if (0 === this.activeTabIndex && loadFromHisto) {
            this._buildCriteriasFromHistory();
        }

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="batch_details({ batchId : row.entity.batchId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var isQualiCellTemplate =
            '<a class="grid-cell-link" ui-sref="batch_details({ batchId : row.entity.batchId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{"IS_QUALI_"+COL_FIELD | translate}}</div></a>';
        var statusCellTemplate =
            '<a class="grid-cell-link" ui-sref="batch_details({ batchId : row.entity.batchId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD | translate}} {{row.entity.batchStatus == "IN_ERROR" ? ("status_batch.error_" + row.entity.batchErrorCode | translate) : ""}}</div></a>';

        var allColumnDefs = [
            {
                name: 'batchId',
                displayName: 'dashboard.column.batch.batch.id',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                type: 'number',
            },
            {
                name: 'created',
                displayName: 'dashboard.column.envelope.created',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                sort: { direction: this.uiGridConstants.DESC, priority: 0 },
                cellFilter: "date:'short'",
            },
            {
                name: 'batchStatus',
                displayName: 'dashboard.column.envelope.status',
                cellTemplate: statusCellTemplate,
                headerCellFilter: 'translate',
                cellFilter: 'translate',
                sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                    return this._sortingStatus(a, b, rowA, rowB, direction);
                },
            },
            {
                name: 'updated',
                displayName: 'dashboard.column.folder.last.modified',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                cellFilter: "date:'short'",
            },
            {
                name: 'sentDate',
                displayName: 'dashboard.column.envelope.sent',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                cellFilter: "date:'short'",
            },
            {
                name: 'folderId',
                displayName: 'dashboard.column.folder.folder.id',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                type: 'number',
            },
            {
                name: 'envelopeId',
                displayName: 'dashboard.column.envelope.id',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
                type: 'number',
            },
            {
                name: 'principalName',
                displayName: 'dashboard.column.envelope.principal',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'companyName',
                displayName: 'dashboard.column.envelope.company.name',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'sender',
                displayName: 'dashboard.column.envelope.sender',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'senderEmail',
                displayName: 'dashboard.column.envelope.sender.email',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'numDoc',
                displayName: 'dashboard.column.batch.numDoc',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'ladProviderName',
                displayName: 'dashboard.column.batch.ladProvider',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'isQuali',
                displayName: 'dashboard.column.batch.target',
                cellTemplate: isQualiCellTemplate,
                headerCellFilter: 'translate',
            },
            {
                name: 'delay',
                displayName: 'dashboard.column.batch.delay',
                cellTemplate: defaultCellTemplate,
                headerCellFilter: 'translate',
            },
        ];

        this.batchGridOptions = {
            columnDefs: this._getColumns(allColumnDefs),
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            exporterFieldCallback: (grid, row, col, value) => {
                if (col.name === 'created' || col.name === 'updated') {
                    value = this.dateFilter(value, 'shortDate');
                } else if (col.name === 'batchStatus') {
                    value = this.$translate.instant(value);
                    value +=
                        row.entity.batchStatus === 'IN_ERROR'
                            ? this.$translate.instant('status_batch.error_' + row.entity.batchErrorCode)
                            : '';
                } else if (col.name === 'isQuali') {
                    value = this.$translate.instant('IS_QUALI_' + value);
                }
                return value;
            },
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridBatchApi = gridApi;
            },
        };
    }

    clearSearchBatchs() {
        this._initBatchsSearchFilter();
        this._initBatchsSearchValues();
        this.batchGridOptions.data = this._searchByCriterias();
        this._saveCriterias();
    }

    searchBatchs() {
        this._cleanBatchsFormParam();
        if (this._isIndexFileOverdue()) {
            this._addSpecificsForIndexOverdue();
        }
        this.criteriaBat.companyName = this.selected.company && this.selected.company.companyName;
        this.criteriaBat.senderName =
            this.selected.seller && this.selected.seller.legalEntity && this.selected.seller.legalEntity.name;

        this.batchPromise = this._searchByCriterias().$promise;
        this.batchPromise.then(data => {
            this.batchGridOptions.data = this._addComputedProps(data);
        });
        this._saveCriterias();
    }

    // Indique si l'export CSV de la grille peut être réalisé
    canExportGrid() {
        if (!(this.gridBatchApi === undefined || this.gridBatchApi.selection === undefined)) {
            return this.gridBatchApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    exportGridCsv() {
        // Nom du fichier CSV : epdf_DateHeure_dataLots.csv
        var now = new Date();
        var filename = 'epdf_' + this.DateService.formatAsYMD_HM(now) + '_dataLots.csv';
        this.batchGridOptions.exporterCsvFilename = filename;

        var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
        this.gridBatchApi.exporter.csvExport('selected', 'all', myElement);
    }

    getBatchIdsSelected() {
        var batchIds = '';
        if (!(this.gridBatchApi === undefined || this.gridBatchApi.selection === undefined)) {
            var selectedRows = this.gridBatchApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                batchIds += selectedRows[i].batchId + ';';
            }
        }
        return batchIds;
    }

    getTableHeight() {
        var rowHeight = 30;
        var headerHeight = 30;
        var scrollHeight = 20;
        var footerHeight = 32;
        return {
            height:
                this.gridBatchApi.core.getVisibleRows(this.gridBatchApi.grid).length * rowHeight +
                headerHeight +
                scrollHeight +
                footerHeight +
                'px',
        };
    }

    init(tabIndex) {
        if (tabIndex === this.activeTabIndex && this.loadFromHisto) {
            this._buildCriteriasFromHistory();
        }
    }

    _buildCriteriasFromHistory() {
        var histoCriteriaBat = this.$sessionStorage.batchHistorySearchCriteria;
        if (histoCriteriaBat) {
            this.criteriaBat = histoCriteriaBat;
            if (this._isIndexFileOverdue()) {
                //rebuild de la date d'envoi
                if (this.criteriaBat.sentDateFrom) {
                    this.sentDates.sentDateFrom = this.criteriaBat.sentDateFrom;
                    this.sentDates.sentTimeFrom = this.criteriaBat.sentDateFrom;
                }
                if (this.criteriaBat.sentDateTo) {
                    this.sentDates.sentDateTo = this.criteriaBat.sentDateTo;
                    this.sentDates.sentTimeTo = this.criteriaBat.sentDateTo;
                }
            } else {
                //Normalement on doit jamais tomber dans ce cas car un reset est normalement demandé?? Donc au ou ce n'est pas fait, on s'assure de supprimer les
                //criteres specifiques aux lots en retard de rapprochement!!
                delete this.criteriaBat.sentDateFrom;
                delete this.criteriaBat.sentDateTo;
                delete this.criteriaBat.expectedDateTo;
            }
        }
    }

    _addComputedProps(data) {
        var newdata = data;
        if (this._isIndexFileOverdue()) {
            var currentDate = moment();
            newdata = _.map(data, row => {
                row.delay = currentDate.diff(moment(row.expectedDate), 'days');
                return row;
            });
        }
        return newdata;
    }
    _addSpecificsForIndexOverdue() {
        var sentDateFrom = this.sentDates.sentDateFrom ? moment(this.sentDates.sentDateFrom) : null;
        if (sentDateFrom && this.sentDates.sentTimeFrom) {
            var sentTimeFrom = moment(this.sentDates.sentTimeFrom);
            sentDateFrom.set('hour', sentTimeFrom.get('hour'));
            sentDateFrom.set('minute', sentTimeFrom.get('minute'));
            sentDateFrom.set('second', sentTimeFrom.get('second'));
            sentDateFrom.set('millisecond', sentTimeFrom.get('millisecond'));
        }
        var sentDateTo = this.sentDates.sentDateTo ? moment(this.sentDates.sentDateTo) : null;
        if (sentDateTo && this.sentDates.sentTimeTo) {
            var sentTimeTo = moment(this.sentDates.sentTimeTo);
            sentDateTo.set('hour', sentTimeTo.get('hour'));
            sentDateTo.set('minute', sentTimeTo.get('minute'));
            sentDateTo.set('second', sentTimeTo.get('second'));
            sentDateTo.set('millisecond', sentTimeTo.get('millisecond'));
        }
        this.criteriaBat.sentDateFrom = sentDateFrom ? sentDateFrom.toDate() : null;
        this.criteriaBat.sentDateTo = sentDateTo ? sentDateTo.toDate() : null;
        this.criteriaBat.expectedDateTo = moment().toDate();
        this.criteriaBat.batchStatus = 'SENT_TO_PRESTA';
    }

    _saveCriterias() {
        this.$sessionStorage.batchHistorySearchCriteria = this.criteriaBat;
    }

    _searchByCriterias() {
        var criterias = angular.copy(this.criteriaBat);
        if (criterias.batchIds) {
            const stringArray = criterias.batchIds.split(';');
            criterias.batchIds = stringArray.map(str => parseInt(str));
        } else {
            criterias.batchIds = [];
        }
        var createdDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaDates.createdDateFrom,
            this.criteriaDates.createdTimeFrom
        );
        criterias.createdDateFrom = createdDateFrom;
        var createdDateTo = this.UtilSvc.mixteDateTime(
            this.criteriaDates.createdDateTo,
            this.criteriaDates.createdTimeTo
        );

        criterias.createdDateTo = createdDateTo;
        var updatedDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaDates.updatedDateFrom,
            this.criteriaDates.updatedTimeFrom
        );

        criterias.updatedDateFrom = updatedDateFrom;
        var updatedDateTo = this.UtilSvc.mixteDateTime(
            this.criteriaDates.updatedDateTo,
            this.criteriaDates.updatedTimeTo
        );

        criterias.updatedDateTo = updatedDateTo;

        return this.BatchService.searchByCriterias(criterias);
    }

    _getColumns(allColumnDefs) {
        var selectedColumns;
        if (this._isIndexFileOverdue()) {
            selectedColumns = [
                'batchId',
                'created',
                'batchStatus',
                'sentDate',
                'folderId',
                'envelopeId',
                'principalName',
                'companyName',
                'ladProviderName',
                'delay',
            ];
        } else {
            selectedColumns = [
                'batchId',
                'created',
                'batchStatus',
                'updated',
                'folderId',
                'envelopeId',
                'principalName',
                'companyName',
                'sender',
                'senderEmail',
                'numDoc',
                'ladProviderName',
                'isQuali',
            ];
        }
        var columnsDefs = _.filter(allColumnDefs, columnDef => {
            return selectedColumns.indexOf(columnDef.name) !== -1;
        });
        return columnsDefs;
    }

    _sortingStatus(a, b, rowA, rowB /*, direction*/) {
        var statusTransA = this.$translate.instant(a);
        var statusTransB = this.$translate.instant(b);

        if (a === 'IN_ERROR') {
            statusTransA += ' ' + this.$translate.instant('status_batch.error_' + rowA.entity.batchErrorCode);
        }
        if (b === 'IN_ERROR') {
            statusTransB += ' ' + this.$translate.instant('status_batch.error_' + rowB.entity.batchErrorCode);
        }
        return statusTransA.localeCompare(statusTransB);
    }

    _initBatchsSearchValues() {
        if (this._isIndexFileOverdue()) {
            this.criteriaDates.sentTimeFrom = new Date();
            this.criteriaDates.sentTimeFrom.setHours(0, 0, 0, 0);
            this.criteriaDates.sentTimeTo = new Date();
            this.criteriaDates.sentTimeTo.setHours(23, 59, 0, 0);
        } else {
            this.criteriaDates.createdDateFrom = new Date();
            this.criteriaDates.createdDateFrom.setHours(0, 0, 0, 0);
            this.criteriaDates.createdDateTo = new Date();
            this.criteriaDates.createdDateTo.setHours(0, 0, 0, 0);
        }

        this.criteriaDates.createdTimeFrom = new Date();
        this.criteriaDates.createdTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaDates.createdTimeTo = new Date();
        this.criteriaDates.createdTimeTo.setHours(23, 59, 0, 0);
        this.criteriaDates.updatedTimeFrom = new Date();
        this.criteriaDates.updatedTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaDates.updatedTimeTo = new Date();
        this.criteriaDates.updatedTimeTo.setHours(23, 59, 0, 0);
        this.criteriaBat.companyName = this.selected.company && this.selected.company.companyName;
        this.criteriaBat.senderName =
            this.selected.seller && this.selected.seller.legalEntity && this.selected.seller.legalEntity.name;
    }

    _cleanBatchsFormParam() {
        if (this.criteriaBat.batchStatus === '') {
            this.criteriaBat.batchStatus = undefined;
        }
        if (this.criteriaBat.target === '') {
            this.criteriaBat.target = undefined;
        }
    }

    _initBatchsSearchFilter() {
        if (this._isIndexFileOverdue()) {
            this.criteriaBat.sentDateFrom = null;
            this.criteriaBat.sentDateTo = null;
        }
        this.criteriaBat.batchIds = undefined;
        this.criteriaBat.batchStatus = undefined;
        this.criteriaBat.folderId = undefined;
        this.criteriaBat.principalId = undefined;
        this.criteriaBat.ladProviderId = undefined;
        this.criteriaBat.sender = undefined;
        this.criteriaBat.senderEmail = undefined;
        this.criteriaBat.envelopeId = undefined;
        this.criteriaBat.companyName = undefined;
        this.criteriaBat.senderName = undefined;
        this.criteriaBat.target = undefined;
        this.criteriaBat.numDoc = undefined;
        this.criteriaBat.refClient = undefined;
        this.criteriaDates.createdDateFrom = undefined;
        this.criteriaDates.createdDateTo = undefined;
        this.criteriaDates.createdTimeFrom = undefined;
        this.criteriaDates.createdTimeTo = undefined;
        this.criteriaDates.updatedDateFrom = undefined;
        this.criteriaDates.updatedDateTo = undefined;
        this.criteriaDates.updatedTimeFrom = undefined;
        this.criteriaDates.updatedTimeTo = undefined;
        this.$scope.$broadcast('angucomplete-alt:clearInput', 'companyName');
        this.$scope.$broadcast('angucomplete-alt:clearInput', 'senderName');
    }
    _isIndexFileOverdue() {
        return this.specificFormBatch === 'indexfileOverdue';
    }

    getTemplate() {
        return './batch.html';
    }
}

angular.module('dashboard').component('batch', {
    templateUrl: require('./batch.html'),
    controller: batchCtrl,
});

angular.module('dashboard').component('batchInboundDelay', {
    templateUrl: require('./indexfileOverdue.html'),
    controller: batchCtrl,
});
